<template>
  <div>
    <center>
      <h1>Account</h1>
      <p>Manage your Account Settings</p>
    </center>
    <hr>
    <center>
      <div v-if="showButtons" class="selectorButtons">
        <h1>Select an Option:</h1>
        <v-btn id="updateSelectorButton" color="success" @click="showUpdateAccountInfoForm()">Update Account Info</v-btn>
        <br>
        <v-btn id="passwordSelectorButton" color="error" @click="showChangePasswordForm()">Change Password</v-btn>
      </div>
    </center>
    <div class="form">
      <div class="backButton">
        <v-btn v-if="!showButtons" @click="backButton()" class="ma-2" color="orange darken-2" dark><v-icon darkleft>mdi-arrow-left</v-icon>Back</v-btn>
      </div>
      <div v-if="showPasswordForm" id=password-form>
        <v-form ref="accountinfo" v-model="valid" lazy-validation>
          <v-text-field type="password" v-model="password" :rules="passwordRules" label="New Password" required> </v-text-field>
          <v-text-field type="password" v-model="passwordConfirm" :rules="passwordRules" label="Confirm New Password" required> </v-text-field>
          <v-btn id="update-button" :disabled="!valid" color="success" @click="changePassword(password, passwordConfirm)">Change Password</v-btn>
        </v-form>
      </div>
      <div v-if="showUpdateForm" id=update-form>
        <v-form ref="accountinfo" v-model="valid" lazy-validation>
          <v-text-field v-model="firstname" :rules="firstnameRules" label="First Name" required> </v-text-field>
          <v-text-field v-model="lastname" :rules="lastnameRules" label="Last Name" required> </v-text-field>
          <v-text-field v-model="email" :rules="emailRules" label="Email Address" required> </v-text-field>
          <v-text-field v-if="allowText" v-model="phone" :rules="phoneRules" label="10 Digit Phone Number" :counter="10" required> </v-text-field>
          <v-btn id="update-button" :disabled="!valid" color="success" @click="updateAccountInfo(firstname, lastname, phone, email, null)">Update My Info</v-btn>
        </v-form>
        <p>To change your default county, please contact <a :href="`mailto:${supportEmail}`">{{supportEmail}}</a></p>
      </div>
    </div>
    <v-snackbar :color="snackbar.color" v-model="snackbar.show" timeout="3000">
      {{ snackbar.message }} 
      <v-btn text @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
// import { set } from 'vue/types/umd';
export default {
  data: () => ({
    valid: false,
    showUpdateForm: false,
    showPasswordForm: false,
    showButtons: true,
    allowText: false,
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    username: '',
    password: '',
    passwordConfirm: '',
    supportEmail: "support@firewatch101.com",
    loading: false,
    snackbar: {
      show: false,
      message: null,
      color: "primary"

    },
    firstnameRules: [
        v => !!v || 'First Name is Required',
      ],
    lastnameRules: [
        v => !!v || 'Last Name is Required',
      ],
    emailRules: [
        v => !!v || 'Email address is required',
        v => /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Email must be valid'
      ],
    phoneRules: [
        v => !!v || 'Phone number is Required',
        v => /^\d{10}$/.test(v) || 'Phone number must be valid'
      ],
    passwordRules: [
        v => !!v || 'Password is Required',
        v => /^.{6,}/.test(v) || 'Password must contain at least 6 characters'
      ],
    }),
  name: 'App',

  components: {
  },

  created(){
    if (!localStorage.username){
      localStorage.removeItem('token');
      this.$router.push('login');
      return
    }
    if (localStorage.allow_text == "true"){
      this.allowText = true;
    }
    window.scrollTo(0,0);
    this.getAccountInfo();
  },
  methods: {
    error(message){
      this.snackbar.show = true;
      this.snackbar.message = message;
      this.snackbar.color = "error";
    },
    async updateAccountInfo(firstname, lastname, phone, email, password){
      this.loading = true;

      const userUpdateResponse = await fetch(localStorage.apiURL + "/app/userInfo", {
        method: "PUT",
        headers: {"Content-Type": "application/json", "deviceID": localStorage.token, "tokenID": localStorage.tokenID},
        body: JSON.stringify({
          email: email,
          firstname: firstname,
          lastname: lastname,
          phone: phone,
          password: password
        })
      })

      if (!userUpdateResponse.ok){
        this.loading = false;
        this.error("api returned " + userUpdateResponse.status);
        return;
      }

      const userUpdateData = await userUpdateResponse.json()

      if (!userUpdateData.success){
        this.loading = false;
        this.error("An error occured: " + userUpdateData.msg);
        return;
      } else {
      
      this.showUpdateForm = false;
      this.showPasswordForm = false;

      alert("Your account has been updated. You will be directed back to your watchlist")
      this.$router.push({path: 'watchlist'});
  
      }

    },
    changePassword(password, passwordConfirm){
      if (password.length < 6){
        this.error("Password to short...Try again");
        return;
      }

      if (password != passwordConfirm){
        this.error("Passwords do not match...Try again");
        return;
      }

      this.updateAccountInfo(this.firstname, this.lastname, this.phone, this.email, password);
    },
    showChangePasswordForm(){
      this.showButtons = false;
      this.showPasswordForm = true;

    },
    showUpdateAccountInfoForm(){
      this.showButtons = false;
      this.showUpdateForm = true;
    },
    backButton(){
      this.showPasswordForm = false;
      this.showUpdateForm = false;
      this.valid = false;
      this.showButtons = true;
    },
    async getAccountInfo(){
      this.loading = true;

      const userInfoRequest = await fetch(localStorage.apiURL + "/app/userInfo", {
        method: "GET",
        headers: {"deviceID": localStorage.token, "tokenID": localStorage.tokenID}
      })

      if (!userInfoRequest.ok){
        this.loading = false;
        this.error("api returned " + userInfoRequest.status);
        return;
      }

      const userInfoData = await userInfoRequest.json();

      if(!userInfoData.success){
        this.error("An error occured: " + userInfoData.msg)
        this.loading = false
        return;
      }

      this.firstname = userInfoData.userData.first_name;
      this.lastname = userInfoData.userData.last_name;
      this.email = userInfoData.userData.email;
      this.phone = userInfoData.userData.phone;
    }
  },
};
</script>

<style scoped>
@media screen and (max-width: 1500px) {
  .form {
    margin-top: 25px;
    margin-left: 20px;
    margin-right: 20px;
    align-content: center;
  }
}
@media screen and (min-width: 1500px) {
  .form {
    margin-top: 100px;
    margin-left: 25%;
    align-content: center;
    width: 50%
  }
}

.backButton{
  margin-bottom: 50px;
}

#update-button {
 margin-bottom: 25px;
}
.selectorButtons{
  margin-top: 100px;
}

#updateSelectorButton{
  margin-top: 50px;
}

#passwordSelectorButton{
  margin-top: 25px;
}
</style>
